module.exports = __webpack_public_path__ + "media/images/candidate-experience-survey-feedback-d4b3b245a334527c65283bfe42a4316e.svg";